import { useContext, useEffect } from "react";
import { useUpdate } from "ahooks";
import { Tabs } from "antd";
import { Context } from "../EditorContext";

import ConfigPanel from "../ContentConfig";

import SettingForm from "./SettingForm";
import SEOForm from "./SEOForm";
import TeaserForm from "./TeaserForm";
import ContentPanel from "./ContentPanel";
import LayoutPanel from "./LayoutPanel";
import SignupSettingForm from "./SignupSettingForm";

export default () => {
  const { shareRefs, addSubscriber, sideContent } = useContext(Context);

  const update = useUpdate();

  useEffect(() => {
    // subscribe select node;
    addSubscriber({ type: "NODE_SELECT", fn: update });

    // maybe remove..
  }, [addSubscriber, update]);

  return (
    <div style={{ position: "relative" }}>
      {shareRefs && shareRefs.selectedNode && (
        <ConfigPanel
          key={shareRefs.selectedNode.id}
          node={shareRefs.selectedNode}
        />
      )}
      <Tabs
        tabBarStyle={{ paddingLeft: 10, paddingRight: 10, marginBottom: 0 }}
        className="tab-bar-space-around"
        size="small"
      >
        {sideContent.hasOwnProperty("content") && (
          <Tabs.TabPane
            className="rip-mm-tabs-height"
            tab="Content"
            key="content"
          >
            <ContentPanel />
          </Tabs.TabPane>
        )}

        {sideContent.hasOwnProperty("layout") && (
          <Tabs.TabPane
            className="rip-mm-tabs-height"
            tab="Layout"
            key="layout"
          >
            <LayoutPanel />
          </Tabs.TabPane>
        )}

        {sideContent.hasOwnProperty("setting") && (
          <Tabs.TabPane
            className="rip-mm-tabs-height"
            tab="Setting"
            key="setting"
          >
            <SettingForm />
          </Tabs.TabPane>
        )}

        {sideContent.hasOwnProperty("signup") && (
          <Tabs.TabPane
            className="rip-mm-tabs-height"
            tab="Setting"
            key="signupSetting"
          >
            <SignupSettingForm />
          </Tabs.TabPane>
        )}

        {sideContent.hasOwnProperty("seo") && (
          <Tabs.TabPane className="rip-mm-tabs-height" tab="SEO" key="seo">
            <SEOForm />
          </Tabs.TabPane>
        )}

        {sideContent.hasOwnProperty("teaser") && (
          <Tabs.TabPane
            className="rip-mm-tabs-height"
            tab="Teaser"
            key="teaser"
          >
            <TeaserForm />
          </Tabs.TabPane>
        )}
      </Tabs>
    </div>
  );
};
